module.exports = __webpack_public_path__ + "6ba2fb4a5ea1c174b952eb2efebeb41f.svg";